<template>
    <div>
        <tab name="4"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="一级选项" :value="1"></el-option>
                            <el-option label="二级选项" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="仅看已启用的" :value="1"></el-option>
                        <el-option label="仅看已禁用的" :value="0"></el-option>
                        <el-option label="不限制状态" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="addLabel">新增选项值</el-button>
            <el-button  type="danger"  size="small" :disabled="tabaleDataSelected.length === 0" :loading="disableLoading" @click="disable">禁用</el-button>
            <el-button  type="primary"  size="small" :disabled="tabaleDataSelected.length === 0" :loading="enableLoading" @click="enable">启用</el-button>
        </div>
        <div>
            <el-alert type="warning" effect="light" :closable="false">
                <div slot="title">如需添加修改选项分类，或者需要修改标签值所属分类，请联系研发</div>
            </el-alert>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 1">启用</span>
                        <span v-else>禁用</span>
                    </template>
                </el-table-column>
                <el-table-column prop="styleName" label="一级选项"></el-table-column>
                <el-table-column prop="tagName" label="二级选项"></el-table-column>
				<el-table-column prop="modifyTime" label="更新时间"></el-table-column>
                <el-table-column fixed="right" label="操作" :width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="manage(scope.row)" >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <LabelManage ref="labelManage" @submitSuccess="manageSuccess"></LabelManage>
    </div>
</template>

<script>
import LabelManage from './components/LabelManage'
import Tab from '../components/tab.vue'
export default {
    components:{LabelManage, Tab},
    data(){
        this.defaultParams = {
            // 查询类型 1：标签分类 2：标签值
            type: 1,
            // 查询参数
            value: null,
            // -1：不限状态 1:启用 0：停用
            status: 1,
            pageNo: 1,
			searchType:0,
            pageSize: this.$pageSizes[0]
        };

        return {
            data: [],
            dataList: [],
            params:{
                ...this.defaultParams,
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || null,
                status: parseInt(this.$route.query.status || this.$route.query.status == 0 ? this.$route.query.status : 1),
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				searchType:0
            },
            listLoading: true,
            tabaleDataSelected: [],
            disableLoading: false,
            enableLoading: false
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            this.listLoading = true;

            const res = await this.$request({
                url: '/styleTag/tag/list',
                method: 'post',
                data: {...this.params}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 多选
        handleSelectionChange(selected) {
            this.tabaleDataSelected = selected;
        },
        // 新增标签
        addLabel() {
            this.$refs.labelManage.show();
        },
        // 禁用
        async disable() {
            const tagIds = this.tabaleDataSelected.filter(item => item.status === 1).map(item => item.tagId);

            if(tagIds.length !== this.tabaleDataSelected.length) {
                return this.$alert('有标签已经是禁用状态，请重新选择', '提示', {confirmButtonText: '确认', dangerouslyUseHTMLString: true, type: 'info', center: true });
            }

            this.disableLoading = true;

            const res = await this.$request({
                url: '/styleTag/tag/batch',
                method: 'post',
                data: {tagIds, type: 0,searchType:0}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.disableLoading = false;
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.getDataList();
        },
        // 启用
        async enable() {
            const tagIds = this.tabaleDataSelected.filter(item => item.status === 0).map(item => item.tagId);

            if(tagIds.length !== this.tabaleDataSelected.length) {
                return this.$alert('有标签已经是启用状态，请重新选择', '提示', {confirmButtonText: '确认', dangerouslyUseHTMLString: true, type: 'info', center: true });
            }

            this.enableLoading = true;

            const res = await this.$request({
                url: '/styleTag/tag/batch',
                method: 'post',
                data: {tagIds, type: 1,searchType:0}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.enableLoading = false;
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.getDataList();
        },
        // 管理
        manage(row) {
            this.$refs.labelManage.show({...row});
        },
        manageSuccess() {
            this.getDataList();
        }
    }
}
</script>